// Copyright 2025, University of Maryland, All Rights Reserved
export const SCORE_MIN = 1
export const SCORE_MAX = 5

export function parseScore(value: string): number | null {
  const trimmed = value.trim()
  if (!trimmed) return null

  const parsed = Number(trimmed)
  if (!Number.isInteger(parsed)) return null
  if (parsed < SCORE_MIN || parsed > SCORE_MAX) return null

  return parsed
}
